$(function() {

setTimeout( function() {
  if(getParam('product')){
    var productName = getParam('product');
    console.log(productName);
    $('.globo-formbuilder span.label-content').each(function(){
      if($(this).text() == '商品名'){
        console.log(productName);
        $(this).parents('label').next('input').val(productName);
      }
    });
    
  }
}, 500 );
  function getParam(name, url) {
      if (!url) url = window.location.href;
      name = name.replace(/[\[\]]/g, "\\$&");
      var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, " "));
  }
});

